import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IDriver } from 'src/core/interfaces/driver';
import { Observable } from 'rxjs';
import { IDashboardMainReportDto } from 'src/core/interfaces/dashboardMainReportDto';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }


  getMainReport(from: Date, to: Date,customerId=null): Observable<any> {
      // Format dates to YYYY-MM-DD
      // debugger
      const formatDate = (date: Date): string =>
        date.toISOString().split('T')[0];
  
      let params = new HttpParams()
      .set('from', formatDate(from))
      .set('to', formatDate(to));
    
    if (customerId) {
      params = params.set('customer_id', customerId); // Update the existing params
    }
    return this.http.get<any>(`${this._baseUrl}/Dashboard/MainReport`, { params });
  }
  // Get a driver by ID
  
}
